import { Routes, Route, BrowserRouter } from "react-router-dom";
import { RequireAuth } from "../contexts/UserContext";
import PageLayout from "../pages/PageLayout";
import routes from "./routeConstants";

const AppRoutes = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<PageLayout />}>
        {routes.map((route) =>
          route.private ? (
            <Route
              key={route.path}
              exact
              path={route.path}
              element={<RequireAuth>{route.element}</RequireAuth>}
            />
          ) : (
            <Route
              key={route.path}
              exact
              path={route.path}
              element={route.element}
            />
          )
        )}
      </Route>
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
